import { DropdownIndicator } from "@ui-kit/Dropdown";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";
import { tui } from "../locale";

export const UnpublishedDot = () => (
	<Tooltip>
		<TooltipTrigger asChild>
			<span
				aria-label={tui("unpublished-label")}
				className="relative ml-auto flex size-4 shrink-0 items-center justify-center before:absolute before:-inset-2 before:content-['']"
				data-testid="workspace-tools-unpublished-dot"
				role="img"
			>
				<DropdownIndicator className="bg-status-warning" />
			</span>
		</TooltipTrigger>
		<TooltipContent className="max-w-72">{tui("unpublished")}</TooltipContent>
	</Tooltip>
);
